import { Star } from "lucide-react";
import GoodPayerBadge from "@/components/GoodPayerBadge";

// Compact organizer reputation block used on invites and event detail.
export default function OrganizerRep({ org, compact = false }) {
  if (!org) return null;
  return (
    <div data-testid="organizer-rep" className="flex items-center gap-3">
      <div className="h-11 w-11 rounded-sm bg-[#1C1C24] overflow-hidden flex items-center justify-center font-bold shrink-0">
        {org.photo ? <img src={org.photo} alt="" className="h-full w-full object-cover" /> : (org.stage_name?.[0] || "?")}
      </div>
      <div className="min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="font-semibold truncate">{org.stage_name}</span>
          {org.good_payer && <GoodPayerBadge level={org.payer_level} />}
        </div>
        <div className="flex items-center gap-2 text-xs text-zinc-400 mt-0.5 flex-wrap">
          {org.rating?.count > 0
            ? <span className="flex items-center gap-1 text-amber-400"><Star className="h-3.5 w-3.5 fill-amber-400" />{org.rating.avg} ({org.rating.count})</span>
            : <span className="text-zinc-500">Sem avaliações</span>}
          <span>· {org.events_done} eventos realizados</span>
          {!compact && <span>· {org.musicians_hired} contratados</span>}
          <span>· {org.on_time_percent}% pagam. no prazo</span>
        </div>
      </div>
    </div>
  );
}
